import {IntermediatePart} from "../../intermediatePart";

export default class LightFixture extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "light_fixture";
    this.partName = "Light Fixture";
  }

  load(dbFeature) {
    return super.load_(dbFeature, new LightFixture());
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Globals.LightFixture;
    }
  }
}
